import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, User, LogOut, Settings, Moon, Sun } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useData } from '../context/DataContext';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const { user, logout, isAdmin } = useAuth();
  const { searchContent } = useData();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (query.trim()) {
      const results = searchContent(query);
      setSearchResults(results);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  };

  const handleResultClick = (scriptId) => {
    navigate(`/script/${scriptId}`);
    setShowResults(false);
    setSearchQuery('');
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="header">
      <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
        <h1 style={{ 
          fontWeight: '700', 
          fontSize: '1.5rem', 
          letterSpacing: '0.5px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
        }}>MSSQLDBATeam.com</h1>
      </Link>
      
      <div className="header-actions">
        <button onClick={toggleTheme} className="theme-toggle">
          {isDark ? <Sun size={20} /> : <Moon size={20} />}
        </button>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="Search scripts..."
            className="search-input"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            onBlur={() => setTimeout(() => setShowResults(false), 200)}
          />
          <Search className="search-icon" size={18} />
          
          {showResults && searchResults.length > 0 && (
            <div className="search-results">
              {searchResults.slice(0, 5).map(script => (
                <div
                  key={script.id}
                  className="search-result-item"
                  onClick={() => handleResultClick(script.id)}
                >
                  <div className="result-title">{script.title}</div>
                  <div className="result-category">{script.category} - {script.subcategory}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        {user ? (
          <div className="user-menu">
            <User size={20} />
            <span>{user.name}</span>
            {isAdmin && (
              <Link to="/admin" className="admin-link">
                <Settings size={16} />
              </Link>
            )}
            <button onClick={handleLogout} className="logout-btn">
              <LogOut size={16} />
            </button>
          </div>
        ) : (
          <Link to="/login" className="login-link">
            Login
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;